import { useState, useEffect } from 'react';

export default function StickyBar() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Afficher la barre après 300px de scroll
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t-2 border-rose-200 shadow-2xl z-50 animate-slide-up">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between max-w-6xl mx-auto">
          <div className="flex items-center gap-4">
            <div className="flex">
              {[1,2,3,4,5].map((star) => (
                <i key={star} className="ri-star-fill text-rose-500 text-sm"></i>
              ))}
            </div>
            <span className="text-sm font-semibold text-gray-900">4.9/5</span>
            <span className="hidden md:inline text-sm text-gray-600">• 2 500+ clientes satisfaites</span>
          </div>
          
          <button className="px-6 py-3 bg-rose-500 text-white font-bold rounded-full hover:bg-rose-600 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap">
            Voir les best-sellers
          </button>
        </div>
      </div>
    </div>
  );
}
